import { Injectable } from '@angular/core';
import { isJwtExpired } from '../utils/jwt-payload';

const STORAGE_KEY = 'holli_mail_assistent_passport_v1';

@Injectable({
  providedIn: 'root',
})
export class HolliSessionService {
  getPassportToken(): string | null {
    if (typeof sessionStorage === 'undefined') {
      return null;
    }
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw == null || raw.trim() === '') {
      return null;
    }
    return raw.trim();
  }

  setPassportToken(token: string): void {
    if (typeof sessionStorage === 'undefined') {
      return;
    }
    sessionStorage.setItem(STORAGE_KEY, token.trim());
  }

  clearPassportToken(): void {
    if (typeof sessionStorage === 'undefined') {
      return;
    }
    sessionStorage.removeItem(STORAGE_KEY);
  }

  hasValidPassportToken(): boolean {
    const t = this.getPassportToken();
    if (t === null) {
      return false;
    }
    return !isJwtExpired(t);
  }
}
